import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "survey-details" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "text-muted-foreground"
}
const _hoisted_5 = { class: "text-sm text-muted-foreground" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "notes-content" }
const _hoisted_8 = { class: "ui-field" }
const _hoisted_9 = {
  key: 0,
  class: "ui-empty"
}
const _hoisted_10 = {
  key: 1,
  class: "ui-empty"
}
const _hoisted_11 = {
  key: 2,
  class: "space-y-3"
}
const _hoisted_12 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_13 = { class: "text-xs text-muted-foreground" }
const _hoisted_14 = { class: "text-sm mt-2" }
const _hoisted_15 = {
  key: 0,
  class: "text-muted-foreground"
}
const _hoisted_16 = {
  key: 0,
  class: "text-xs text-muted-foreground mt-1"
}
const _hoisted_17 = {
  key: 1,
  class: "notes-content mt-3"
}
const _hoisted_18 = {
  key: 2,
  class: "border-t pt-3 mt-3"
}
const _hoisted_19 = { class: "notes-content" }

import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Textarea } from '@/components/ui/textarea';
import { Spinner } from '@/components/ui/spinner';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from '@/components/ui/sheet';
import { Save } from '@lucide/vue';

import { ref, watch } from 'vue';
import axios from 'axios';
import { dateTimeToDateWithTimeString } from '@/filters/date_filters';
import SurveyChart from '@/components/SurveyChart.vue';

interface Survey {
  id: number;
  date: string;
  property_name: string;
  property_id?: number;
  property_city?: string;
  position: string;
  contact_name: string;
  contact_person_id?: number;
  vote: number;
  notes: string;
  comments: string;
  ip: string | null;
  city_name?: string;
}

interface Props {
  modelValue: boolean;
  survey: Survey | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SurveyDetailDrawer',
  props: {
    modelValue: { type: Boolean },
    survey: {}
  },
  emits: ["update:modelValue", "survey-updated"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const drawerTab = ref('details');
const loadingPropertyHistory = ref(false);
const propertyHistory = ref<Survey[]>([]);
const savingComment = ref(false);
const canComment = ref(false);
const commentText = ref('');

function formatDateTime(dateTime: string): string {
  return dateTimeToDateWithTimeString(dateTime) || '';
}

async function loadPropertyHistory(propertyId: number) {
  loadingPropertyHistory.value = true;
  try {
    const response = await axios.get('/api/surveys/property_history/', {
      params: { property_id: propertyId },
    });
    propertyHistory.value = response.data;
  } catch (e) {
    console.error('Error loading property history:', e);
    propertyHistory.value = [];
  } finally {
    loadingPropertyHistory.value = false;
  }
}

async function checkCommentPermission() {
  try {
    const permResponse = await axios.get('/api/surveys/permissions/');
    canComment.value = permResponse.data.can_comment || false;
  } catch (e) {
    canComment.value = false;
  }
}

async function saveComment() {
  if (!props.survey) return;

  savingComment.value = true;
  try {
    await axios.patch(`/api/surveys/${props.survey.id}/add_comment/`, {
      comments: commentText.value,
    });
    emit('survey-updated');
  } catch (e) {
    console.error('Error saving comment:', e);
  } finally {
    savingComment.value = false;
  }
}

watch(
  () => props.survey,
  (newSurvey) => {
    if (newSurvey) {
      commentText.value = newSurvey.comments || '';
      drawerTab.value = 'details';
      checkCommentPermission();

      if (newSurvey.property_id) {
        loadPropertyHistory(newSurvey.property_id);
      }
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Sheet), {
    open: __props.modelValue,
    "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(SheetContent), {
        class: "survey-drawer",
        side: "right"
      }, {
        default: _withCtx(() => [
          (__props.survey)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_unref(SheetHeader), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(SheetTitle), null, {
                      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                        _createTextVNode("Детали отзыва", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_unref(SheetDescription), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.survey.property_name) + " ", 1),
                        (__props.survey.property_city)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_1, "· " + _toDisplayString(__props.survey.property_city), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Tabs), {
                  modelValue: drawerTab.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drawerTab).value = $event)),
                  class: "min-w-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(TabsList), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(TabsTrigger), { value: "details" }, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createTextVNode("Детали", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_unref(TabsTrigger), { value: "history" }, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode("История", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(TabsContent), {
                      value: "details",
                      class: "drawer-content space-y-5"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("dl", _hoisted_2, [
                          _createElementVNode("div", null, [
                            _cache[6] || (_cache[6] = _createElementVNode("dt", null, "Дата и время отзыва", -1)),
                            _createElementVNode("dd", null, _toDisplayString(formatDateTime(__props.survey.date)), 1)
                          ]),
                          (__props.survey.ip)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _cache[7] || (_cache[7] = _createElementVNode("dt", null, "IP-адрес", -1)),
                                _createElementVNode("dd", null, [
                                  _createTextVNode(_toDisplayString(__props.survey.ip) + " ", 1),
                                  (__props.survey.city_name)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, " (" + _toDisplayString(__props.survey.city_name) + ") ", 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", null, [
                            _cache[8] || (_cache[8] = _createElementVNode("dt", null, "Контактное лицо", -1)),
                            _createElementVNode("dd", null, [
                              _createElementVNode("strong", null, _toDisplayString(__props.survey.contact_name), 1),
                              _createElementVNode("p", _hoisted_5, _toDisplayString(__props.survey.position), 1)
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _cache[9] || (_cache[9] = _createElementVNode("dt", null, "Оценка", -1)),
                            _createElementVNode("dd", null, [
                              _createVNode(_unref(Badge), {
                                variant: 
                      __props.survey.vote >= 9
                        ? 'success'
                        : __props.survey.vote >= 7
                          ? 'secondary'
                          : __props.survey.vote >= 5
                            ? 'warning'
                            : 'destructive'
                    
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(__props.survey.vote) + " из 10 ", 1)
                                ]),
                                _: 1
                              }, 8, ["variant"])
                            ])
                          ]),
                          (__props.survey.notes)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _cache[10] || (_cache[10] = _createElementVNode("dt", null, "Отзыв клиента", -1)),
                                _createElementVNode("dd", _hoisted_7, _toDisplayString(__props.survey.notes), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("label", _hoisted_8, [
                          _cache[11] || (_cache[11] = _createElementVNode("span", { class: "ui-label" }, "Комментарий менеджера", -1)),
                          _createVNode(_unref(Textarea), {
                            modelValue: commentText.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((commentText).value = $event)),
                            rows: "5",
                            placeholder: "Добавьте комментарий…",
                            readonly: !canComment.value
                          }, null, 8, ["modelValue", "readonly"])
                        ]),
                        (canComment.value)
                          ? (_openBlock(), _createBlock(_unref(Button), {
                              key: 0,
                              disabled: savingComment.value,
                              class: "w-full",
                              onClick: saveComment
                            }, {
                              default: _withCtx(() => [
                                (savingComment.value)
                                  ? (_openBlock(), _createBlock(_unref(Spinner), { key: 0 }))
                                  : (_openBlock(), _createBlock(_unref(Save), {
                                      key: 1,
                                      size: 15
                                    })),
                                _cache[12] || (_cache[12] = _createTextVNode(" Сохранить комментарий ", -1))
                              ]),
                              _: 1
                            }, 8, ["disabled"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(TabsContent), {
                      value: "history",
                      class: "space-y-5"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(SurveyChart, {
                          title: "Динамика оценок",
                          "property-id": __props.survey.property_id,
                          "show-period-filter": false,
                          period: "all_time"
                        }, null, 8, ["property-id"]),
                        _createElementVNode("section", null, [
                          _cache[17] || (_cache[17] = _createElementVNode("h3", { class: "section-small-title" }, "История оценок объекта", -1)),
                          (loadingPropertyHistory.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createVNode(_unref(Spinner)),
                                _cache[13] || (_cache[13] = _createElementVNode("span", null, "Загрузка истории…", -1))
                              ]))
                            : (!propertyHistory.value.length)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Нет истории оценок"))
                              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(propertyHistory.value, (historyItem) => {
                                    return (_openBlock(), _createElementBlock("article", {
                                      key: historyItem.id,
                                      class: _normalizeClass(["survey-history-item", {
                    'current-survey': historyItem.id === __props.survey.id,
                    'contact-person-survey':
                      historyItem.contact_person_id === __props.survey.contact_person_id &&
                      historyItem.id !== __props.survey.id,
                  }])
                                    }, [
                                      _createElementVNode("div", _hoisted_12, [
                                        _createVNode(_unref(Badge), {
                                          variant: 
                        historyItem.vote >= 9
                          ? 'success'
                          : historyItem.vote >= 7
                            ? 'secondary'
                            : historyItem.vote >= 5
                              ? 'warning'
                              : 'destructive'
                      
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(historyItem.vote), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["variant"]),
                                        _createElementVNode("time", _hoisted_13, _toDisplayString(formatDateTime(historyItem.date)), 1),
                                        (historyItem.contact_person_id === __props.survey.contact_person_id)
                                          ? (_openBlock(), _createBlock(_unref(Badge), {
                                              key: 0,
                                              variant: "outline"
                                            }, {
                                              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                                _createTextVNode(" Тот же контакт ", -1)
                                              ]))]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (historyItem.id === __props.survey.id)
                                          ? (_openBlock(), _createBlock(_unref(Badge), {
                                              key: 1,
                                              variant: "secondary"
                                            }, {
                                              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                                _createTextVNode("Текущий", -1)
                                              ]))]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("p", _hoisted_14, [
                                        _createElementVNode("strong", null, _toDisplayString(historyItem.contact_name), 1),
                                        (historyItem.position)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, " · " + _toDisplayString(historyItem.position), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      (historyItem.city_name || historyItem.ip)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(historyItem.city_name || historyItem.ip), 1))
                                        : _createCommentVNode("", true),
                                      (historyItem.notes)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(historyItem.notes), 1))
                                        : _createCommentVNode("", true),
                                      (historyItem.comments)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                            _cache[16] || (_cache[16] = _createElementVNode("h4", { class: "text-xs text-muted-foreground mb-1" }, "Комментарий менеджера", -1)),
                                            _createElementVNode("p", _hoisted_19, _toDisplayString(historyItem.comments), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 2))
                                  }), 128))
                                ]))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})